import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { restEndpoint } from 'config';

@Injectable()
export class InternalRequestHttpInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isInternalRequest(request.url)) {
            request = request.clone({
                url: this.buildInternalUrl(request.url)
            });
        }

        return next.handle(request);
    }

    isInternalRequest(url: string): boolean {
        return _.startsWith(url, '/');
    }

    buildInternalUrl(requestUrl: string): string {
        return `${restEndpoint}/internal${requestUrl}`;
    }
}
